import { inject } from '@angular/core';
import { NonNullableFormBuilder } from '@angular/forms';
import type { ResolveFn } from '@angular/router';
import type { PartialDeep } from 'type-fest';
import { CacheService } from '../../../../common/services/cache.service';
import { PreferencesService } from '../../../../common/services/preferences.service';
import type { DriverFormResolverData } from '../../drivers.routes';
import { DriversStorageKey } from '../enums/drivers-storage-key';
import type { DriverForm } from '../helpers/driver-form.helper';
import { DriverFormHelper } from '../helpers/driver-form.helper';

export const addDriverResolver: ResolveFn<DriverFormResolverData> = () => {
  const cacheService = inject(CacheService);
  const fb = inject(NonNullableFormBuilder);
  const preferencesService = inject(PreferencesService);

  const cache = cacheService.get<PartialDeep<DriverForm>>(
    DriversStorageKey.ADD_DRIVER_FORM,
    { keepOnNavigation: true },
  );

  const form = DriverFormHelper.buildForm(fb, preferencesService);
  const initial = form.getRawValue();

  return { initial, form: cache ?? initial };
};
